// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__n96u9"};